import { render } from "./SectionAboutWelcomeDesc.vue?vue&type=template&id=6cb2873a&scoped=true"
import script from "./SectionAboutWelcomeDesc.vue?vue&type=script&lang=js"
export * from "./SectionAboutWelcomeDesc.vue?vue&type=script&lang=js"

import "./SectionAboutWelcomeDesc.vue?vue&type=style&index=0&id=6cb2873a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb2873a"]])

export default __exports__